import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AnalyticsModule } from 'src/app/shared/analytics/analytics.module'
import { SvgModule } from '../../shared/svg/svg.module'
import { FavoritesCtaComponent } from './favorites-cta.component'
import { LinkModule } from 'src/app/libs/link/link.module'

@NgModule({
  imports: [CommonModule, SvgModule, LinkModule],
  exports: [FavoritesCtaComponent],
  declarations: [FavoritesCtaComponent]
})
export class FavoritesCtaModule {}
